export default "__VITE_ASSET__B9ym$DDs__"